export default __webpack_public_path__ + "static/media/plus-disabled.d9ee49a6.svg";